// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"2846be65","496":"b8bd16a5"}[chunkId] + ".chunk.js";
};